import { render, staticRenderFns } from "./tobeprocessed-order-list.vue?vue&type=template&id=752eb7dc&"
import script from "./tobeprocessed-order-list.vue?vue&type=script&lang=js&"
export * from "./tobeprocessed-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports